<template>
  <div class="main">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline d-s-s f-w">
        <el-form-item label="名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus" v-auth="'/study/diycategory/add'">添加</el-button>
          <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check" v-auth="'/study/diycategory/batch'">批量操作</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="list">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="gray" v-if="scope.row.status == 0">隐藏</span>
              <span class="green" v-if="scope.row.status == 1">显示</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" sortable="custom"></el-table-column>

          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small" v-auth="'/study/diycategory/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/study/diycategory/del'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>


    <!--弹窗引入-->
    <Add v-if="show_popup['add']" :is_open="show_popup['add']" :oneform="Oneform" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--批量操作-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :ids="ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>

  </div>
</template>

<script>
  import DiycategoryApi from '@/api/study/diycategory.js';
  import Add from './part/Add.vue';
  import Batch from './part/Batch.vue';

  export default {
    components: {
      Add,
      Batch
    },
    data() {
      return {
        //加载
        loading: true,

        //搜索控制
        searchForm: {
          name: '',
        },

        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/

        /*选中的对象*/
        multipleSelection: [],
        ids: [],

        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },

        show_popup: {
          add: false,
          batch: false,
        },
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*批量row_key*/
      getRowKey (row) {
        return row.id;
      },

      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.id);
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;//加载中
        self.curPage = 1;
        self.getData();//获取数据
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getData();
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;

        //请求接口
        DiycategoryApi.getList(Params, true).then(res => {

          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          //请求接口
          DiycategoryApi.del({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });

        });
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.Oneform.type = name;
        if (name == 'edit') name = 'add';
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.Oneform.model = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
      
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/diycategory/index.vue